import * as React from 'react';

import { ComponentPropsWithoutStyles } from '@/util/ComponentPropsWithoutStyles';

import * as styles from './label.css';

export const Label: React.FC<
  ComponentPropsWithoutStyles<React.HTMLAttributes<HTMLLabelElement>>
> = ({ children, ...props }) => (
  <label className={styles.label} {...props}>
    {children}
  </label>
);
